export const auth = {
  get token() {
    return localStorage.getItem("token");
  },
  set token(v) {
    if (v) localStorage.setItem("token", v);
    else localStorage.removeItem("token");
  },
  get user() {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  },
  set user(v) {
    if (v) localStorage.setItem("user", JSON.stringify(v));
    else localStorage.removeItem("user");
  },
  clear() {
    this.token = null;
    this.user = null;
  },
};